export default __webpack_public_path__ + "static/media/exclamation-late.e88e5ae3.svg";